<template lang="jade">
  div.Pager(v-if="pages > 1")
    a.Pager__prev(":disabled"="page <= 1"
                  @click="page--")
      i.fa.fa-long-arrow-left
      span.Pager__text previous

    a.Pager__next(":disabled"="page >= pages"
                  @click.prevent="page++")
      span.Pager__text next
      i.fa.fa-long-arrow-right
</template>

<script>
export default {
  data: () => ({}),
  props: {
    page: {
      type: Number,
      coerce: x => parseInt(x),
      required: true
    },
    records: {
      type: Number,
      coerce: x => parseInt(x),
      required: true
    },
    limit: {
      type: Number,
      coerce: x => parseInt(x),
      required: true
    }
  },
  computed: {
    pages () {
      return Math.ceil((this.records / this.limit))
    }
  }
}
</script>



// WEBPACK FOOTER //
// basic.vue?4430d7b8